export default "__VITE_ASSET__DdoBsYdY__"